export enum MembershipType {
  PERSONAL = 'personal',
  SPOUSE = 'spouse',
  KIDS = 'kids',
}
